import React from 'react';
import MessagesCenter from '../../components/MessagesCenter';

/**
 * ClientMessagesCenter — Iter-270 client inbox page.
 * Mounts the same unified inbox; backend synthesizes the role-appropriate
 * cards (event channels, system notifications, payments, invoices, AI recs).
 */
const ClientMessagesCenter = () => <MessagesCenter pageTitle="Messages" />;

export default ClientMessagesCenter;
